var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{attrs:{"flat":""}},[(!_vm.id)?_c('edit-survey-settings',{attrs:{"id":_vm.id}}):_c('survey-builder',{attrs:{"id":_vm.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }